import Vue from "vue"
import { PRERECORDING_KEY } from "./shared/keys/prerecording-key"
import onDOMContentLoaded from "./shared/scripts/on-dom-content-loaded"
import { getHandlers, handlerClickBehavior } from "./shared/scripts/handler"
import { createContainer } from "./shared/scripts/container"
import VueScreenSize from "vue-screen-size"
import PrerecordingModal from "./view/PrerecordingModal"
import PublicMixin from "@public-modal/shared/mixins/public-mixin"
import { EventBus } from "~events"

Vue.use(VueScreenSize)
onDOMContentLoaded(async () => {
    let handlers = getHandlers(PRERECORDING_KEY)

    const { productId } = window

    if (!handlers.length) {
        await new Promise(resolve => {
            EventBus.$on("lesson-loaded", () => {
                handlers = getHandlers(PRERECORDING_KEY)
                resolve()
            })
        })
    }

    if (!handlers.length) {
        return
    }

    Vue.mixin(PublicMixin)

    const container = createContainer(PRERECORDING_KEY)

    new Vue({
        el: container,
        render: h =>
            h(PrerecordingModal, {
                props: {
                    config: {
                        key: "PRODUCT_PRERECORDING",
                        data: {
                            productId
                        }
                    }
                }
            })
    })

    handlers.forEach(h => {
        h.addEventListener("click", () => {
            handlerClickBehavior(PRERECORDING_KEY)
        })
    })
})
